<app-view-title [isPrimaryColor]="true" Title="{{ 'Intellitrailer.Rental.InviteFriends.HeadlineMsg' | translate : 'Invite friends'}}"></app-view-title>
<view-content [centered]="true">
  <div class="cards-container">
    <ng-container>
      <ng-container *ngIf="!loading">
        <app-card>
          <ng-container>
            <div class="title invite-friends-title"><strong>{{ appTitle }}</strong></div>
            <p class="invite-friends-p">
              <span [innerHTML]="appDescription"></span>
              @if (this.discountModel.CampaignTerms) {
              <span class="material-icons toggle-rule-info-icon" (click)="showRule()">
                info
              </span>
              }
            </p>
            
            <button class="invite-button" mat-raised-button (click)="openOffer()">
              {{ 'Intellitrailer.Rental.InviteFriends.btnInvite' | translate : 'Invite' }}
            </button>
          </ng-container>
        </app-card>
      </ng-container>
      <div class="summary-area">
        <ng-container *ngIf="!loading">
          <h3 class="summary-title">
            {{ 'Intellitrailer.Rental.InviteFriends.HowItWorks' | translate : 'How it works' }}
          </h3>
          <div class="summary-grid">
            <div class="summary-item">
              <div class="invite-friends-image-icons download"></div>
              <div class="summary-text">
                <p class="summary-heading">{{ 'Intellitrailer.Rental.InviteFriends.ShareUse4FreeViaTheApp' | translate : "Share Use4Free via the app" }}</p>
              </div>
            </div>
            <div class="summary-item">
              <div class="invite-friends-image-icons upload"></div>
              <div class="summary-text">
                <p class="summary-heading">{{ 'Intellitrailer.Rental.InviteFriends.YourFriendDownloadsTheApp' | translate : 'Your friend downloads the app' }}</p>
              </div>
            </div>
            <div class="summary-item">
              <div class="invite-friends-image-icons trailer"></div>
              <div class="summary-text">
                <p class="summary-heading">{{ 'Intellitrailer.Rental.InviteFriends.YourFriendRentsYouAreInDraw' | translate : "Your friend rents – you're in the draw" }}</p>
              </div>
            </div>
          </div>
          <div class="invite-board">
            <h2 class="invite-board-title">{{ 'Intellitrailer.Rental.InviteFriends.InviteBoard' | translate : 'Invite board' }}</h2>
            <hr class="invite-board-divider" />
            <ng-container *ngIf="discountModel.InvitedFriends?.length > 0; else noFriends">
              <div class="friends-list">
                <div class="friend-item" *ngFor="let friend of discountModel.InvitedFriends">
                  <span class="friend-details">{{ friend.Name }}</span>
                  <span class="friend-details">{{ friend.Date | date: 'dd-MMM' }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #noFriends>
              <p class="invite-board-empty-msg">
                {{ 'Intellitrailer.Rental.InviteFriends.messageInviteBoard1' | translate : "You haven’t completed any referrals yet." }}<br />
                {{ 'Intellitrailer.Rental.InviteFriends.messageInviteBoard2' | translate : "Share Use4Free with your friends – every successful booking earns you a spot in the gift card draw!" }}
              </p>
            </ng-template>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="loading">
        <div style="margin:auto; padding-top:15px; width: 100px; height: 100px; top:55vh; left: 35%; display: inline-block">
          <mat-progress-spinner diameter="50" mode="indeterminate" style="margin:auto"></mat-progress-spinner>
          <div style="text-align: center; width: 100px; margin-top: 25px">
            {{ 'Intellitrailer.Rental.InviteFriends.Loadingoffer' | translate : 'Loading campaign' }}
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</view-content>
<view-actions></view-actions>
